import type { RecMatchRow } from '../../../../../types/api/v1'

/**
 * Navigation utility for Recent Activity links
 * Determines whether to navigate to drill-in view (single invoice) or filtered match view (multiple invoices)
 */

interface NavigationParams {
  match: RecMatchRow
  invoiceNumber: string
}

interface NavigationResult {
  url: string
  isDirectLink: boolean // true for drill-in, false for filtered view
}

/**
 * Generates navigation URL - always navigates to details page
 * Updated to provide consistent navigation behavior for all items
 */
export function generateNavigationUrl({ match, invoiceNumber }: NavigationParams): NavigationResult {
  return {
    url: `/supplier_rec/match_view/${match.id}`,
    isDirectLink: true,
  }
}

/**
 * Helper function to extract the primary invoice number from a match
 */
export function getPrimaryInvoiceNumber(match: RecMatchRow): string {
  return match.invoice_numbers?.[0]?.number || 'Unknown'
}

/**
 * Enhanced navigation function that includes invoice number extraction
 */
export function generateNavigationUrlForMatch(match: RecMatchRow, specificInvoiceNumber?: string): NavigationResult {
  const invoiceNumber = specificInvoiceNumber || getPrimaryInvoiceNumber(match)

  return generateNavigationUrl({
    match,
    invoiceNumber,
  })
}
